<button (click)="emptyPropertiesModal = modalService.openTemplateModal(propertyViewModal, 'sm')"
        *ngIf="allPropsShow"
        class="btn btn-primary btn-sm btn-block"
        data-action="openProperties"
>
	<span>
		{{ 'PROPERTIES.SHOW_PROPS' | translate }}
	</span>
</button>

<div *ngFor="let props of customProperties"
     class="mb-2">
    <div *ngIf="props.default_view || props.property_values || props.property_values===false">
        <ul class="list-group">
            <li class="list-group-item">
                <ng-container *ngTemplateOutlet="propTemplates; context: {props: props}">
                </ng-container>
            </li>
        </ul>
    </div>
</div>

<ng-template #propertyViewModal
             let-modal>
    <app-button-modal-close [modalSize]="'sm'"
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <div *ngFor="let props of customProperties"
             class="mb-2">
            <div *ngIf="!props.default_view && !props.property_values">
                <ng-container *ngTemplateOutlet="propTemplates; context: {props: props}">
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>

<!--  Модалка для выбора значений проперти  -->
<ng-template #propertyEditModal
             let-modal>
    <app-button-modal-close [modalSize]="modalSize"
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <ng-container [ngSwitch]="editingProperty.property.property_type">

            <!-- select FILE navigator -->
            <ng-template ngSwitchCase="property_file">
                <app-component-file-navigator
                        (eventSelected)="editingProperty.property_values = $event;"
                        (eventSubmit)="setProperty(editingProperty.property_values, modal)"
                        [isMultiple]="editingProperty.property.is_multiform"
                        [selects]="editingProperty.property_values">
                </app-component-file-navigator>
            </ng-template>

            <!-- select member -->
            <ng-template ngSwitchCase="property_member">
                <div>
                    <h2>{{ 'PROPERTIES.TOOLTIPS.MEMBER' | translate }}</h2>
                    <h2 *ngIf="editingProperty.property.is_multiform">{{ 'PROPERTIES.MULTIPLE' | translate }}</h2>
                    <p>{{ 'PROPERTIES.ACCESS.ACCESS' | translate }}
                        : {{ 'PROPERTIES.ACCESS.' + editingProperty.property.property_type_target | translate }}</p>

                    <div class="list-group">
                        <div *ngFor="let value of editingProperty.property_values"
                             class="list-group-item list-group-item-action "
                             style="display: flex">
                            <div (click)="helper.openProfileByGuid(value.guid)"
                                 style="width: 100%">
                                <span class="pointer">{{ helper.fullName(value) }}</span>
                            </div>
                            <i (click)="deleteItemOfPropertyValues(value)"
                               class="bi bi-trash"
                               style="color: red; float: right; cursor: pointer"
                            ></i>
                        </div>
                    </div>

                    <select #members (change)="addValueToPropertyValues(members.value)"
                            class="form-select"
                            class="mt-2">
                        <option hidden>{{ 'PROPERTIES.VALUE' | translate }}</option>
                        <option *ngFor="let member of allMembers"
                                value="{{member.guid}}">{{ helper.fullName(member) }}
                        </option>
                    </select>
                </div>

                <button (click)="setProperty(editingProperty.property_values, modal)"
                        class="btn btn-success mt-3">
                    <span>{{ 'BUTTON_TEXT.ONLY_SAVE' | translate }}</span>
                </button>
            </ng-template>

            <!-- select BOOlEAN -->
            <ng-template ngSwitchCase="property_boolean">
                <h2>{{ 'PROPERTIES.TOOLTIPS.BOOLEAN' | translate }}: {{ editingProperty.property.title }}</h2>
                <h1>
					<span (click)="setProperty(true, modal)"
                          [class]="editingProperty.property_values === true ? 'active-badge' : 'inactive-badge'"
                          class="badge text-bg-success me-1 p-1"
                    >
						<i class="bi bi-check-square me-1"></i> {{ 'PROPERTIES.VALUES.TRUE' | translate }}
					</span>
                    <span (click)="setProperty(null, modal)"
                          [class]="editingProperty.property_values === null ? 'active-badge' : 'inactive-badge'"
                          class="badge text-bg-secondary me-1 p-1"
                    >
						<i class="bi bi-square me-1"></i> {{ 'PROPERTIES.VALUES.EMPTY' | translate }}
					</span>
                    <span (click)="setProperty(false, modal)"
                          [class]="editingProperty.property_values === false ? 'active-badge' : 'inactive-badge'"
                          class="badge text-bg-danger p-1"
                    >
						<i class="bi bi-x-square me-1"></i> {{ 'PROPERTIES.VALUES.FALSE' | translate }}
					</span>
                </h1>
            </ng-template>

            <!-- select catalog (список) -->
            <ng-template *ngIf="selectedCatalog"
                         ngSwitchCase="property_catalog">
                <h2>{{ 'PROPERTIES.CATALOG' | translate }} {{ selectedCatalog.title }}</h2>
                <h2 *ngIf="editingProperty.property.is_multiform">{{ 'PROPERTIES.MULTIPLE' | translate }}</h2>

                <div class="list-group">
                    <div *ngFor="let value of editingProperty.property_values"
                         class="list-group-item list-group-item-action"
                         style="display: flex">
                        <div style="width: 100%">
                            <span>{{ value.items_text }}</span>
                        </div>
                        <i (click)="deleteItemOfPropertyValues(value)"
                           class="bi bi-trash"
                           style="color: red; float: right; cursor: pointer"
                        ></i>
                    </div>
                </div>
                <select #catalog (change)="addValueToPropertyValues(catalog.value)"
                        class="mt-2"
                        class="form-select">
                    <option hidden>{{ 'PROPERTIES.VALUE' | translate }}</option>
                    <option *ngIf="selectedCatalog.is_open || currentMember.project_setting.is_project_admin"
                            [value]="'newItem'"
                    >
                        {{ 'PROPERTIES.ADD_VALUE' | translate }}
                    </option>
                    <option *ngFor="let item of selectedCatalog.items"
                            [value]="item.id"
                    >
                        {{ item.items_text }}
                    </option>
                </select>

                <div *ngIf="catalog.value === 'newItem'"
                     class="mt-2"
                     style="display: inline-flex; width: 100%">
                    <input #newItem
                           (change)="newCatalogItemText = newItem.value"
                           [value]="newCatalogItemText"
                           style="width: 80%">
                    <button (click)="addCatalogItem()"
                            class="btn btn-success">
						<span>
							<i class="bi bi-check"></i>
                            {{ 'BUTTON_TEXT.CREATE' | translate }}
						</span>
                    </button>
                </div>

                <button (click)="setProperty(editingProperty.property_values, modal)"
                        class="btn btn-success mt-3">
                    <span>{{ 'BUTTON_TEXT.ONLY_SAVE' | translate }}</span>
                </button>
            </ng-template>

            <!-- select property_todo (список boolean) -->
            <!--            <ng-template ngSwitchCase="property_todo">-->
            <!--                <h2>Справочник {{ editingProperty.property.title }}</h2>-->

            <!--                <div *ngFor="let catalogItem of editingProperty.catalog.items">-->
            <!--                    <input type="checkbox"-->
            <!--                           class="me-1"-->
            <!--                           style="width: auto"-->
            <!--                           (change)="changeCheckInTodo(catalogItem.id)"-->
            <!--                           [id]="catalogItem.id"-->
            <!--                           [checked]="editingProperty.property_values.includes(catalogItem.id)"-->
            <!--                    >-->
            <!--                    <label [for]="catalogItem.id">-->
            <!--                        {{ catalogItem.items_text }}-->
            <!--                    </label>-->
            <!--                </div>-->

            <!--                <button (click)="setProperty(editingProperty.property_values.toString(), modal)"-->
            <!--                        class="btn btn-success mt-3">-->
            <!--                    <span>Сохранить</span>-->
            <!--                </button>-->
            <!--            </ng-template>-->
        </ng-container>
    </div>
</ng-template>

<!--  Шаблоны разных проперти  -->
<ng-template #propTemplates
             let-props="props">
    <ng-container [ngSwitch]="props.property.property_type">
        <!-- FILE template -->
        <ng-template ngSwitchCase="property_file">
            <i class="bi bi-file-earmark-word"
               ngbTooltip="{{ 'PROPERTIES.TOOLTIPS.DOCUMENTS' | translate }}"
            ></i>
            <i *ngIf="props.property.is_multiform"
               class="bi bi-ui-checks ms-1 me-1"
               ngbTooltip="{{ 'PROPERTIES.MULTIPLE' | translate }}"
            ></i>
            <strong>
                {{ props.property.title }}:
            </strong>
            <span *ngIf="props.property_values"
                  style="float: right">
				<i (click)="openPropertyEditor(props, propertyEditModal)"
                   *ngIf="canEdit"
                   class="bi bi-pen pointer icon"
                ></i>
				<i (click)="clearPropertyValue(props)"
                   *ngIf="canEdit"
                   class="bi bi-trash text-danger pointer icon"
                ></i>
			</span>
            <div>
                <i (click)="openPropertyEditor(props, propertyEditModal)"
                   *ngIf="!props.property_values"
                   [class.pointer]="canEdit">
                    {{ 'PROPERTIES.VALUES.EMPTY' | translate }}
                </i>
                <div *ngIf="props.property_values">
					<span (click)="openDoc(value, docView)"
                          *ngFor="let value of props.property_values; let i = index"
                          style="max-width: inherit; word-break: break-word"
                    >
						<span *ngIf="i !== 0"
                              class="me-1">,<br></span>
						<span class="pointer">{{ value.name }}</span>
					</span>
                </div>
            </div>
        </ng-template>

        <!-- member template -->
        <ng-template ngSwitchCase="property_member">
            <i class="bi bi-person"
               ngbTooltip="{{ 'PROPERTIES.TOOLTIPS.MEMBER' | translate }}"
            ></i>
            <i *ngIf="props.property.is_multiform"
               class="bi bi-ui-checks ms-1 me-1"
               ngbTooltip="{{ 'PROPERTIES.MULTIPLE' | translate }}"
            ></i>
            <strong>
                {{ props.property.title }}:
            </strong>
            <span *ngIf="props.property_values"
                  style="float: right">
				<i (click)="openPropertyEditor(props, propertyEditModal, 'lg')"
                   *ngIf="canEdit"
                   class="bi bi-pen pointer icon"
                ></i>
				<i (click)="clearPropertyValue(props)"
                   *ngIf="canEdit"
                   class="bi bi-trash text-danger pointer icon"
                ></i>
			</span>
            <div>
                <i (click)="openPropertyEditor(props, propertyEditModal, 'lg')"
                   *ngIf="!props.property_values"
                   [class.pointer]="canEdit">
                    {{ 'PROPERTIES.VALUES.EMPTY' | translate }}
                </i>
                <div *ngIf="props.property_values">
					<span (click)="helper.openProfileByGuid(value.guid)"
                          *ngFor="let value of props.property_values; let i = index"
                          style="max-width: inherit; word-break: break-word"
                    >
						<span *ngIf="i !== 0"
                              class="me-1">,<br></span>
						<span class="pointer">{{ helper.fullName(value) }}</span>
					</span>
                </div>
            </div>
        </ng-template>

        <!-- text template -->
        <ng-template ngSwitchCase="property_text">
            <i class="bi bi-card-text"
               ngbTooltip="{{ 'PROPERTIES.TOOLTIPS.TEXT' | translate }}"
            ></i>
            <strong>
                {{ props.property.title }}:
            </strong>
            <div>
                <span>
                    <app-component-input-inline (emitSave)="editingProperty = props; setProperty($event)"
                                                *ngIf="canEdit"
                                                [isNeedConfirm]="!!props.property_values"
                                                [value]="props.property_values">
                    </app-component-input-inline>
                    <span *ngIf="!canEdit && props.property_values"
                          [innerHTML]="props.property_values"
                    ></span>
                    <span *ngIf="!canEdit && !props.property_values"><i>{{ 'PROPERTIES.VALUES.EMPTY' | translate }}</i></span>
                </span>
            </div>
        </ng-template>

        <!-- boolean template -->
        <ng-template ngSwitchCase="property_boolean">
            <i class="bi bi-check2-circle"
               ngbTooltip="{{ 'PROPERTIES.TOOLTIPS.BOOLEAN' | translate }}"
            ></i>
            <strong (click)="openPropertyEditor(props, propertyEditModal, 'sm')">
                {{ props.property.title }}
            </strong>

            <span *ngIf="props.property_values"
                  style="float: right">
				<i (click)="openPropertyEditor(props, propertyEditModal, 'sm')"
                   *ngIf="canEdit"
                   class="bi bi-pen pointer icon"
                ></i>
				<i (click)="clearPropertyValue(props)"
                   *ngIf="canEdit"
                   class="bi bi-trash text-danger pointer icon"
                ></i>
			</span>
            <div>
                <i (click)="openPropertyEditor(props, propertyEditModal, 'sm')"
                   *ngIf="props.property_values === null"
                   [class.pointer]="canEdit">
                    <i class="bi bi-square"></i> {{ 'PROPERTY.VALUES.EMPTY' | translate }}
                </i>
                <div *ngIf="props.property_values !== null">
					<span>
						<i [class]="props.property_values === true ? 'bi bi-check-square' : 'bi bi-x-square'"></i>
                        {{ (props.property_values === true ? 'PROPERTIES.VALUES.TRUE' : 'PROPERTIES.VALUES.FALSE' )| translate }}
					</span>
                </div>
            </div>
        </ng-template>

        <!-- catalog template -->
        <ng-template ngSwitchCase="property_catalog">
            <div [ngbTooltip]="(props.property.property_type_target ? '' : 'PROPERTIES.CATALOG_DELETED') | translate ">
                <i [class.text-danger]="!props.property.property_type_target"
                   class="bi bi-justify"
                   ngbTooltip="{{ 'PROPERTIES.TOOLTIPS.CATALOG' | translate }}"
                ></i>
                <i *ngIf="props.property.is_multiform"
                   [class.text-danger]="!props.property.property_type_target"
                   class="bi bi-ui-checks ms-1 me-1"
                   ngbTooltip="{{ 'PROPERTIES.MULTIPLY' | translate }}"
                ></i>
                <strong [class.text-danger]="!props.property.property_type_target">
                    {{ props.property.title }}:
                </strong>

                <span *ngIf="props.property_values"
                      style="float: right">
					<i (click)="openPropertyEditor(props, propertyEditModal, 'lg')"
                       *ngIf="canEdit"
                       class="bi bi-pen pointer icon"
                    ></i>
					<i (click)="clearPropertyValue(props)"
                       *ngIf="canEdit"
                       class="bi bi-trash text-danger pointer icon"
                    ></i>
				</span>

                <div>
                    <i (click)="openPropertyEditor(props, propertyEditModal, 'lg')"
                       *ngIf="!props.property_values"
                       [class.disabled]="!props.property.property_type_target"
                       [class.pointer]="canEdit && props.property.property_type_target"
                       [class.text-danger]="!props.property.property_type_target">
                        {{ 'PROPERTIES.VALUES.EMPTY' | translate }}
                    </i>
                    <div *ngIf="props.property_values">
					<span *ngFor="let value of props.property_values; let i = index"
                          style="max-width: inherit; word-break: break-word"
                    >
						<span *ngIf="i !== 0"
                              class="me-1">,<br></span>
                        {{ value.items_text }}
					</span>
                    </div>
                </div>
            </div>
        </ng-template>

        <!--  property_todo template  -->
        <ng-template ngSwitchCase="property_todo">
            <div [ngbTooltip]="props.property.property_type_target ? '' : 'PROPERTIES.CATALOG_DELETED' | translate ">
                <i [class.text-danger]="!props.property.property_type_target"
                   class="bi bi-clipboard2-check"
                   ngbTooltip="{{ 'PROPERTIES.TOOLTIPS.TODO' | translate }}"
                ></i>
                <strong [class.text-danger]="!props.property.property_type_target">
                    {{ props.property.title }}:
                </strong>

                <span style="float: right">
					<i (click)="clearPropertyValue(props)"
                       *ngIf="canEdit && props.property_values.length"
                       class="bi bi-trash text-danger pointer icon"
                    ></i>
				</span>

                <div *ngIf="props.catalog">
                    <div *ngFor="let checkedItem of props.property_values">
					    <span (click)="changeCheckInTodo(props, checkedItem)"
                              [class.pointer]="canEdit"
                        >
						    <i class="bi bi-check-square text-success"></i>
                            {{ checkedItem.items_text }}
					    </span>
                    </div>

                    <span (click)="props.show = !props.show"
                          *ngIf="props.catalog.items.length"
                          class="pointer"
                    >
                        {{ 'PROPERTIES.SHOW_ALL' | translate }}
                    </span>

                    <div *ngIf="props.show">
                        <div *ngFor="let uncheckedItem of props.catalog.items">
                            <span (click)="changeCheckInTodo(props, uncheckedItem)"
                                  [class.pointer]="canEdit"
                            >
						        <i class="bi bi-square"></i>
                                {{ uncheckedItem.items_text }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </ng-container>
</ng-template>

<ng-template #docView
             let-modal>
    <app-button-modal-close [modalSize]="'xl'"
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <app-component-doc-view
                [fileUkey]="docData.key"
        ></app-component-doc-view>
    </div>
</ng-template>
